import Grid from "@mui/material/Grid2";
import { FormGroup } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { DataFormat } from "utils";
import { Fragment, ReactNode } from "react";
import { CalculationMethodDetailsByTypeProps } from "@schemas/calculationmethods/schema";

type DetailsField = {
	id: string;
	render: () => ReactNode;
}

const TimeUnitCalculationMethodDetails = ({ calculationMethod, currency, session, hiddenFields }: CalculationMethodDetailsByTypeProps) => {
	const TimeUnitCalculationMethodDetailsFields: DetailsField[] = [
		{
			id: "calculationMethod.price",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: `PRICE_PER_${calculationMethod.timeUnit}` })} overflow="hidden">
						{DataFormat.price(calculationMethod.price, currency.isoCode, session.locale)}
					</FormGroup>
				</Grid>
			),
		},
		{
			id: "calculationMethod.minimumTimeUnitsPayable",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "MINIMUM_TIME_UNITS_PAYABLE" })} overflow="hidden">
						{calculationMethod.minimumTimeUnitsPayable || "-"}
					</FormGroup>
				</Grid>
			),
		},
	];

	return (
		<>
			{TimeUnitCalculationMethodDetailsFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default TimeUnitCalculationMethodDetails;
